import { Component } from '@angular/core';

@Component({
  selector: 'app-overflowing-time-block-month-view-dialog',
  templateUrl: './overflowing-time-block-month-view-dialog.component.html',
  standalone: false,
})
export class OverflowingTimeBlockMonthViewDialogComponent {}
